import { render, staticRenderFns } from "./ModalPreviewCampanhaTable.vue?vue&type=template&id=176100b6&"
import script from "./ModalPreviewCampanhaTable.vue?vue&type=script&lang=js&"
export * from "./ModalPreviewCampanhaTable.vue?vue&type=script&lang=js&"
import style0 from "./ModalPreviewCampanhaTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports